import React, { FunctionComponent } from "react";
import styled from "styled-components";
import theme from "../theme";

const Wrapper = styled.h3`
  margin: 0 0 ${theme.unit * 2}px 0;
  font-size: ${theme.fonts.medium.fontSize};
  line-height: ${theme.fonts.medium.fontSize};
  font-weight: ${theme.fonts.medium.fontWeight};
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const H3: FunctionComponent = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default H3;
